module.exports = __webpack_public_path__ + "img/Slovakia.093b37f7.png";